(function () {
  "use strict";

  function isWithinBusinessHours(startHour, endHour) {
    var now = new Date();

    var weekday = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York",
      weekday: "short"
    }).format(now);

    var hourStr = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York",
      hour: "numeric",
      hour12: false
    }).format(now);

    var hour = parseInt(hourStr, 10);
    if (hour === 24) {
      hour = 0;
    }

    var isWeekday = ["Mon", "Tue", "Wed", "Thu", "Fri"].indexOf(weekday) !== -1;
    var isInHours = hour >= startHour && hour < endHour;

    return isWeekday && isInHours;
  }

  function refreshVisibility(el) {
    var startHour = parseInt(el.getAttribute("data-start-hour"), 10);
    var endHour = parseInt(el.getAttribute("data-end-hour"), 10);

    if (isNaN(startHour) || isNaN(endHour)) {
      return;
    }

    if (isWithinBusinessHours(startHour, endHour)) {
      el.classList.add("is-visible");
    } else {
      el.classList.remove("is-visible");
      el.classList.remove("is-open");
    }
  }

  function initTapToggle(el) {
    var trigger = el.querySelector("[data-live-support-trigger]");
    if (!trigger) {
      return;
    }

    trigger.addEventListener("click", function (event) {
      event.stopPropagation();
      var isOpen = el.classList.contains("is-open");
      if (isOpen) {
        el.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
      } else {
        el.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      }
    });

    document.addEventListener("click", function (event) {
      if (!el.contains(event.target)) {
        el.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
      }
    });
  }

  function init() {
    var elements = document.querySelectorAll("[data-live-support]");
    if (!elements.length) {
      return;
    }

    var revealed = false;

    function reveal() {
      if (revealed) {
        return;
      }
      revealed = true;

      elements.forEach(function (el) {
        refreshVisibility(el);
        initTapToggle(el);
      });

      setInterval(function () {
        elements.forEach(function (el) {
          refreshVisibility(el);
        });
      }, 60000);
    }

    // Wait for LiveChat's own "ready" event - this queues correctly even if
    // tracking.js hasn't finished loading yet, so the button only appears
    // once the widget can actually respond to a click.
    if (window.LiveChatWidget && typeof window.LiveChatWidget.on === "function") {
      window.LiveChatWidget.on("ready", reveal);
    }

    // Fallback in case "ready" never fires (blocked script, slow network,
    // ad blocker) - the button still appears rather than staying hidden forever.
    setTimeout(reveal, 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();